"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConsolePrompt_1 = require("./ConsolePrompt");
const InputChecks_1 = require("./InputChecks");
const FSIServerClientInterface_1 = require("./FSIServerClientInterface");
const ListServer_1 = require("./ListServer");
const axios_1 = __importDefault(require("axios"));
const TaskController_1 = require("./TaskController");
const Queue_1 = require("./Queue");
const Login_1 = require("./Login");
const APITasks_1 = require("./resources/APITasks");
const APIErrors_1 = require("./resources/APIErrors");
const ListLocal_1 = require("./ListLocal");
const FileOps_1 = require("./FileOps");
const MetaDataClient_1 = require("./MetaDataClient");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const Download_1 = require("./Download");
const Upload_1 = require("./Upload");
const LogLevel_1 = require("./LogLevel");
const IArchiveType_1 = require("./utils/IArchiveType");
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class FSIServerClient {
    constructor(host) {
        this.host = host;
        this.maxRecursiveDepth = 255;
        this.currentUser = "anonymous";
        this.clientId = Math.round(100000 * Math.random());
        this.queueId = 1;
        InputChecks_1.InputChecks.HOST(host);
        this.host = host + '/fsi/';
        this.com = new FSIServerClientInterface_1.FSIServerClientInterface(this, LogLevel_1.LogLevel.warn);
        this.classInit = {
            client: this,
            com: this.com
        };
        this.taskController = new TaskController_1.TaskController(this.classInit, "client #" + this.clientId);
        this.iAxios = axios_1.default.create({ headers: { "Accept": "application/json" } });
        this.iAxios.defaults.validateStatus = () => {
            return true;
        };
    }
    lookupMimeType(fileName) {
        return this.com.lookupMimeType(fileName);
    }
    static ENCODE_PATH(path) {
        const parts = path.split("/");
        for (let i = 0; i < parts.length; i++)
            parts[i] = encodeURIComponent(parts[i]);
        path = parts.join("/");
        return path;
    }
    static DEFAULT_PROGRESS_FUNCTION(prg) {
        let msg = "<" + prg.timeElapsed + "> ";
        const qPrg = prg;
        try {
            if (qPrg.task) {
                msg += "step " + qPrg.pos + "/" + qPrg.length + ": ";
                msg += qPrg.currentTask.getMessage() + " - task progress: " + qPrg.task.percent.toFixed(1) + "% progress: ";
                msg += qPrg.percent.toFixed(1) + "%, ETA TASK: " + qPrg.task.eta;
            }
            else {
                msg += prg.currentTask.getMessage() + " - progress: " + prg.percent.toFixed(1);
            }
        }
        catch (e) {
            console.error(e);
        }
        if (prg.bytesTotal) {
            msg += " " + prg.bytesDone + " / " + prg.bytesTotal + " bytes";
        }
        if (qPrg.task && qPrg.task.bytesTotal) {
            msg += " File: " + qPrg.task.bytesDone + " / " + qPrg.task.bytesTotal + " bytes";
        }
        console.log(msg);
    }
    static HAS_VALID_IMAGE_FILE_EXTENSION(path, ignoreCase = true) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_BOOL(ignoreCase, "ignoreCase");
        let res = false;
        if (path && typeof (path.match) === "function") {
            if (ignoreCase) {
                path = path.toLowerCase();
            }
            const match = path.match(FSIServerClient.regExValidFileExtension);
            res = (match !== null);
        }
        return res;
    }
    static VALIDATE_TRANSLATION(translation) {
        InputChecks_1.InputChecks.IS_OBJECT(translation, "translation");
        return FSIServerClientInterface_1.FSIServerClientInterface.VALIDATE_TRANSLATION(translation);
    }
    static FN_FILE_FILTER_VALID_IMAGES(listData, entry) {
        return new Promise((resolve) => {
            return resolve(FSIServerClient.HAS_VALID_IMAGE_FILE_EXTENSION(entry.src));
        });
    }
    setProgressFunction(fnProgress) {
        InputChecks_1.InputChecks.FN_CTX_OR_UNDEFINED(fnProgress, "fnProgress");
        this.fnProgress = fnProgress;
    }
    getProgressFunction() {
        return this.fnProgress;
    }
    setPromptFunction(fnPrompt) {
        InputChecks_1.InputChecks.FN_CTX_OR_UNDEFINED(fnPrompt, "fnPrompt");
        this.fnPrompt = fnPrompt;
    }
    getPromptFunction() {
        return this.fnPrompt;
    }
    setLogLevel(level) {
        InputChecks_1.InputChecks.NUM(level, "level", LogLevel_1.LogLevel.trace, LogLevel_1.LogLevel.none);
        this.com.setLogLevel(level);
    }
    getLogLevel() {
        return this.com.getLogLevel();
    }
    setTranslations(translations) {
        InputChecks_1.InputChecks.IS_OBJECT(translations, "translations");
        this.com.setTranslations(translations);
    }
    getTranslations() {
        return this.com.getTranslations();
    }
    setMaxRecursiveDepth(n) {
        if (!isNaN(n) && n > -1) {
            this.maxRecursiveDepth = n;
        }
        return this.maxRecursiveDepth;
    }
    getMaxRecursiveDepth() {
        return this.maxRecursiveDepth;
    }
    getServerBaseQuery() {
        return this.host + this.getServerBaseQueryPath();
    }
    getServerBaseQueryPath() {
        return "server?";
    }
    getServerBaseURL() {
        return this.host + "server";
    }
    getService(serviceEndpoint) {
        return this.host + 'service/' + serviceEndpoint.toLocaleLowerCase();
    }
    getServicePath(serviceEndpoint) {
        return 'service/' + serviceEndpoint;
    }
    getHost() {
        return this.host;
    }
    setCurrentUser(user) {
        this.currentUser = user || "anonymous";
    }
    getCurrentUser() {
        return this.currentUser;
    }
    setSessionCookie(sessionCookie) {
        this.com.setSessionCookie(sessionCookie);
    }
    getSessionCookie() {
        return this.com.sessionCookie;
    }
    getNewQueueId() {
        return this.queueId++;
    }
    createQueue(options = {}) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        if (options.fnProgress === undefined && this.fnProgress) {
            options.fnProgress = this.fnProgress;
        }
        return new Queue_1.Queue(this.classInit, options);
    }
    isAbortError(err) {
        return this.com.isAbortError(err);
    }
    getNewAbortController() {
        return this.com.getNewAbortController();
    }
    releaseAbortController(abortController) {
        return abortController.release();
    }
    login(username, password, options, taskController) {
        InputChecks_1.InputChecks.LOGIN(username, password);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.login, [this.host, username]);
        return taskController.wrapPromise(new Login_1.Login(this.classInit, taskController).authenticate(username, password, options));
    }
    logout(options, taskController) {
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.logout, [this.host]);
        let ret;
        if (modeNode && !this.com.bLoggedIn) {
            ret = taskController.getErrorPromise(APIErrors_1.APIErrors.logoutNotLoggedIn);
        }
        else {
            ret = taskController.wrapPromise(new Login_1.Login(this.classInit, taskController).logout(options));
        }
        return ret;
    }
    listServer(path, options = {}, taskController) {
        InputChecks_1.InputChecks.LIST_SERVER(path, options);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.readListServer, ["/" + path]);
        return taskController.wrapPromise(new ListServer_1.ListServer(this.classInit, taskController).read(path, options));
    }
    listLocal(path, options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new ListLocal_1.ListLocal(this.classInit, taskController).read(path, options));
    }
    createDirectory(path, copyOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.createDir, [path]);
        if (copyOptions && copyOptions.overwrite) {
            if (!copyOptions.ignoreErrors) {
                copyOptions.ignoreErrors = {};
            }
            copyOptions.ignoreErrors = { 409: true };
        }
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).createDirectory(path, copyOptions));
    }
    renameFile(oldPath, newPath, copyOptions, taskController) {
        taskController = this.initTaskController(taskController);
        return this.rename(oldPath, newPath, "file", copyOptions, false, taskController);
    }
    renameDirectory(oldPath, newPath, copyOptions, taskController) {
        taskController = this.initTaskController(taskController);
        return this.rename(oldPath, newPath, "directory", copyOptions, false, taskController);
    }
    moveFile(oldPath, newPath, copyOptions, taskController) {
        taskController = this.initTaskController(taskController);
        return this.rename(oldPath, newPath, "file", copyOptions, true, taskController);
    }
    moveDirectory(oldPath, newPath, copyOptions, taskController) {
        taskController = this.initTaskController(taskController);
        return this.rename(oldPath, newPath, "directory", copyOptions, true, taskController);
    }
    reImportDir(path, image = true, metaData = true, httpOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.RE_IMPORT(image, metaData);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.reImportDir, [path]);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).reImportDir(path, image, metaData, httpOptions));
    }
    reImportFile(path, image = true, metaData = true, httpOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.RE_IMPORT(image, metaData);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.reImportFile, [path]);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).reImportFile(path, image, metaData, httpOptions));
    }
    deleteFile(path, httpOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.deleteFile, [path]);
        return this.delete(path, "file", httpOptions);
    }
    deleteDirectory(path, httpOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.deleteDir, [path]);
        return this.delete(path, "directory", httpOptions);
    }
    getMetaData(path, options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new MetaDataClient_1.MetaDataClient(this.classInit, taskController).get(path, options));
    }
    setMetaData(path, data, service = "file", options = {}, taskController) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new MetaDataClient_1.MetaDataClient(this.classInit, taskController).set(path, service, data, "saveMetaData", options));
    }
    deleteMetaData(path, data, service = "file", options = {}, taskController) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new MetaDataClient_1.MetaDataClient(this.classInit, taskController).delete(path, service, data, options));
    }
    restoreMetaData(path, data, service = "file", options = {}, taskController) {
        InputChecks_1.InputChecks.META_DATA(path, data, service);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new MetaDataClient_1.MetaDataClient(this.classInit, taskController).restore(path, service, data, options));
    }
    sendServiceCommand(src, service, commands, options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(src, "src");
        InputChecks_1.InputChecks.PATH(service, "service");
        InputChecks_1.InputChecks.PATH(commands, "command");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        service = service.toLocaleLowerCase();
        const self = this;
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.sendServiceCommand, [commands, service, src]);
        return new Promise((resolve, reject) => {
            let url = self.getService(service);
            if (src) {
                if (service === "jobqueue") {
                    const q = new URLSearchParams(commands);
                    q.set("id", src);
                    commands = q.toString();
                }
                else {
                    url += "/" + FSIServerClient.ENCODE_PATH(src);
                }
            }
            self.httpPost(url, commands, options)
                .then((res) => {
                if (res && res.data && res.data.statuscode === 200) {
                    resolve(true);
                }
                else {
                    reject(self.com.err.get(APIErrors_1.APIErrors.invalidServerReply));
                }
            })
                .catch(reject);
        });
    }
    changePassword(currentPassword, newPassWord, options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(currentPassword, "currentPassword");
        InputChecks_1.InputChecks.PATH(newPassWord, "newPassWord");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.changePassWord, [this.getCurrentUser()]);
        return taskController.wrapPromise(new Login_1.Login(this.classInit, taskController).changePassword(currentPassword, newPassWord, options));
    }
    changeUser(user, options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(user, "user");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.changeUser, [user]);
        return new Login_1.Login(this.classInit, taskController).changeUser(user, options);
    }
    getUserList(options = {}, taskController) {
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.getUserList);
        return taskController.wrapPromise(new Login_1.Login(this.classInit, taskController).getUserList(options));
    }
    copyDirectory(path, toPath, listOptions = {}, taskController, queue) {
        InputChecks_1.InputChecks.COPY(path, toPath, listOptions);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).copyDirectory(path, toPath, true, listOptions, queue));
    }
    copyDirectoryContent(path, toPath, listOptions = {}, taskController, queue) {
        InputChecks_1.InputChecks.COPY(path, toPath, listOptions);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).copyDirectory(path, toPath, false, listOptions, queue));
    }
    copyFile(path, toPath, copyOptions, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.PATH(toPath, "toPath");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.copyFile, [path, toPath]);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).copyFile(path, toPath, copyOptions));
    }
    addEntries(paths, options = {}, taskController) {
        InputChecks_1.InputChecks.STRING_ARRAY(paths, "paths");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.addEntries, [paths.length]);
        return taskController.wrapPromise(new ListServer_1.ListServer(this.classInit, taskController).addEntries(paths, options));
    }
    addEntryObjects(entries, options = {}, addOptions = {}, taskController) {
        InputChecks_1.InputChecks.OBJECT_ARRAY(entries, "paths");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        InputChecks_1.InputChecks.IS_OBJECT(addOptions, "addOptions");
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.addEntries, [entries.length]);
        return taskController.wrapPromise(new ListServer_1.ListServer(this.classInit, taskController).addEntryObjects(entries, options, addOptions));
    }
    download(pathOrEntry, targetPath, options, taskController) {
        InputChecks_1.InputChecks.OBJECT_OR_STRING(pathOrEntry, "pathOrEntry");
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new Download_1.Download(this.classInit, taskController).save(pathOrEntry, targetPath, options));
    }
    downloadICCProfile(pathOrEntry, targetPath, options, taskController) {
        InputChecks_1.InputChecks.OBJECT_OR_STRING(pathOrEntry, "pathOrEntry");
        if (modeNode) {
            InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        }
        if (!options) {
            options = {};
        }
        options.getICCProfile = true;
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new Download_1.Download(this.classInit, taskController).save(pathOrEntry, targetPath, options));
    }
    upload(source, targetPath, options = {}, taskController) {
        InputChecks_1.InputChecks.OBJECT_OR_STRING(source, "pathOrEntry");
        InputChecks_1.InputChecks.PATH(targetPath, "targetPath");
        InputChecks_1.InputChecks.IS_OBJECT(options, "options");
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new Upload_1.Upload(this.classInit, taskController).store(source, targetPath, options));
    }
    directoryContains(path, files = [], directories = [], options = {}, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.STRING_ARRAY_OR_EMPTY_ARRAY(files, "files");
        InputChecks_1.InputChecks.STRING_ARRAY_OR_EMPTY_ARRAY(directories, "directories");
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new ListServer_1.ListServer(this.classInit, taskController).directoryContains(path, files, directories, options));
    }
    getAxiosRequestConfigUserAgent(options, headers) {
        const ret = this.getAxiosRequestConfig(options, headers);
        if (modeNode) {
            if (!ret.headers)
                ret.headers = {};
            ret.headers['User-Agent'] = FSIServerClientUtils_1.FSIServerClientUtils.USERAGENT;
        }
        return ret;
    }
    getAxiosRequestConfig(options, headers) {
        const ret = {};
        if (options) {
            if (options.abortController) {
                ret.cancelToken = options.abortController.renewCancelToken();
            }
            if (options.responseType) {
                ret.responseType = options.responseType;
            }
        }
        if (headers) {
            ret.headers = headers;
        }
        return ret;
    }
    httpHead(url, options, headers) {
        return this.request(this.iAxios.head(url, this.getAxiosRequestConfigUserAgent(options, headers)), options);
    }
    httpGet(url, options, headers) {
        return this.request(this.iAxios.get(url, this.getAxiosRequestConfigUserAgent(options, headers)), options);
    }
    httpDelete(url, options, headers) {
        return this.request(this.iAxios.delete(url, this.getAxiosRequestConfigUserAgent(options, headers)), options);
    }
    httpPost(url, payload, options, headers) {
        return this.request(this.iAxios.post(url, payload, this.getAxiosRequestConfigUserAgent(options, headers)), options);
    }
    httpPut(url, payload, options, headers) {
        return this.request(this.iAxios.put(url, payload, this.getAxiosRequestConfigUserAgent(options, headers)), options);
    }
    async hash(str) {
        return new Login_1.Login(this.classInit, this.taskController).getSha256Hash(str);
    }
    formatTimePeriod(ms, includeMS = false, bHuman = true) {
        return FSIServerClientUtils_1.FSIServerClientUtils.FORMAT_TIME_PERIOD(ms, includeMS, bHuman, this.com.getTranslations().timePeriods);
    }
    rename(oldPath, newPath, strService, copyOptions = {}, move = false, taskController) {
        InputChecks_1.InputChecks.RENAME(oldPath, newPath);
        InputChecks_1.InputChecks.SERVICE_FD(strService);
        InputChecks_1.InputChecks.IS_BOOL(move, "move");
        oldPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(oldPath);
        newPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(newPath);
        let taskDef;
        if (strService === "file") {
            taskDef = (move) ? APITasks_1.APITasks.moveFile : APITasks_1.APITasks.renameFile;
        }
        else {
            taskDef = (move) ? APITasks_1.APITasks.moveDir : APITasks_1.APITasks.renameDir;
        }
        taskController = this.initTaskController(taskController);
        taskController.setCurrentTask(LogLevel_1.LogLevel.debug, taskDef, [oldPath, newPath]);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).rename(oldPath, newPath, strService, copyOptions));
    }
    delete(path, strService, httpOptions = {}, taskController) {
        InputChecks_1.InputChecks.PATH(path);
        InputChecks_1.InputChecks.SERVICE_FD(strService);
        taskController = this.initTaskController(taskController);
        return taskController.wrapPromise(new FileOps_1.FileOps(this.classInit, taskController).delete(path, strService, httpOptions));
    }
    request(p, options) {
        return this.com.runAxiosResponsePromise(p, undefined, options);
    }
    initTaskController(taskController) {
        if (!taskController) {
            taskController = this.taskController;
            taskController.reset();
        }
        return taskController;
    }
}
exports.default = FSIServerClient;
FSIServerClient.LogLevel = LogLevel_1.LogLevel;
FSIServerClient.ImportStatus = ListServer_1.ImportStatus;
FSIServerClient.ArchiveType = IArchiveType_1.IArchiveType;
FSIServerClient.utils = FSIServerClientUtils_1.FSIServerClientUtils;
FSIServerClient.version = process.env.FSISERVERCLIENTVERSION;
FSIServerClient.connectorTypesAll = "*";
FSIServerClient.connectorTypesDefault = ["STORAGE", "MULTIRESOLUTION", "STATIC"];
FSIServerClient.connectorTypesImage = ["STORAGE", "MULTIRESOLUTION"];
FSIServerClient.defaultProgress = {
    ctx: global,
    fn: FSIServerClient.DEFAULT_PROGRESS_FUNCTION
};
FSIServerClient.defaultPrompt = {
    ctx: global,
    fn: ConsolePrompt_1.ConsolePrompt.GET
};
FSIServerClient.regExValidFileExtension = /(\.jpg|\.jpeg|\.tif|\.tiff|\.png|\.gif|\.bmp)$/;
